import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import * as Icon from 'react-bootstrap-icons';
import Select from 'react-select';
import { TOAST_ERROR, TOAST_SUCCESS, TOAST_LOADING, TOAST_DISMISS } from "../../../../../utils";
import { imageRequestCreate, imageDownload, imageRequestList } from '../../../../../actions/appsMoreAction';
import { useForm } from 'react-hook-form';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { baseUrl } from '../../../../../utils';
import { togglePlanSection_D } from '../../../../../actions/showDisplayModalAction';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import { Link } from 'react-router-dom';

const DownloadImage = ({ showdwonloadImage, closedwonloadImage }) => {

  const dispatch = useDispatch();
  const authenticated  = useSelector((state) => state.authenticated.userData.UserRule, shallowEqual); 
  const [downloadStatus, setdownloadStatus] = useState(authenticated.download_img);

  const [downloadImage, setdownloadImage] = useState(0);
  const [spinner, setSpinner] = useState(false);

  const { register, handleSubmit, formState: { errors } } = useForm();

  const [downloadImageForm, setdownloadImageForm] = useState(0);
  const [defaultPopup, setdefaultPopup] = useState(0);

  const [downloadWall, setDownloadWall] = useState([]);
  const [downloadRequest, setDownloadRequest] = useState('');
  const [downloadwallId, setdownloadwallId] = useState();

  const onCustomPostSubmit = () => {
    setSpinner(true);
    TOAST_LOADING();

    imageRequestCreate(localStorage.getItem('ownerId'), downloadwallId).then((response) => {

      TOAST_DISMISS();

      if (response.status == 200) {
        TOAST_SUCCESS(response.data.message);
        closedwonloadImage()
       } else {
        TOAST_ERROR(response.data.message);
      }

      setSpinner(false);
    }).catch((error) => {
      TOAST_DISMISS();
      TOAST_ERROR(error.message);
    })
  }


  const getDownloaddata = () => {

    TOAST_LOADING();

    imageDownload(localStorage.getItem('ownerId')).then((response) => {
      if (response.status == 200) {
        response && response.data.response.map((item, Index) => {
          downloadWall.push({ label: item.name, value: item.id })
        })

        setdownloadwallId(response && response.data.response ? downloadWall[0].value : "");
      }
    })

    imageRequestList(localStorage.getItem('ownerId')).then((response) => {
      if (response.status == 200) {
        setDownloadRequest(response.data.response);
        setdownloadImageForm(1);
        setdefaultPopup(1);
        TOAST_DISMISS();
      }
    })
  }


  useEffect(() => {

    if (downloadStatus) {
      getDownloaddata();
      if (showdwonloadImage == false) {
        setdownloadImage(0);
      }
    }
  }, [showdwonloadImage]);


  return (
    <>

      {downloadStatus ?

        defaultPopup ?

          <Modal size="lg" dialogClassName="modal-dialog-centered modal-overflow personalizePopupModal dynamic-popup" className='dynamic-popup' show={showdwonloadImage} onHide={closedwonloadImage} centered>

            <Modal.Header className="personalize_wt" closeButton>
              <Modal.Title className="modal-title">Download Image</Modal.Title>
            </Modal.Header>

            <Modal.Body className='p-0'>
              {downloadImageForm ? downloadImage == 0 && downloadRequest ?
                    <div className="customPostSec postcWrapC p-4">
                      <div className="wallcreateshow">
                        <div className="portlet-body">
                          <div className="d-flex justify-content-end">
                            <Button variant='primary' onClick={(e) => setdownloadImage(1)} className="commanBtn dwnldImgsBtn">Add New</Button>
                          </div>
                          <label className="columnTitle"></label>
                          <div className="table-scrollable table-scrollable-borderless globalTblList mt0">
                            <table className="table table-hover">
                              <tbody>
                                <tr className="uppercase text-center" align="center">
                                  <th align="left" style={{ textAlign: 'left' }}>
                                    Wall Name
                                  </th>
                                  <th>
                                    Status
                                  </th>
                                  <th>
                                    Expire on
                                  </th>
                                  <th>
                                    Action
                                  </th>
                                </tr>
                              </tbody>
                              <tbody>


                                {downloadRequest.map((data) => {

                                  return (<tr className="text-center" align="center">
                                    <td className="authorPicTd text-left"> {data.wall?.name || ''}</td>

                                    <td>
                                      {data.download_complete == 1 ? <font color='green'>Completed</font>
                                        : <font color="orange">In Progress</font>}
                                    </td>

                                    <td>
                                      {data.download_complete == 1 ? data.download_cron_time : <font color="orange">-</font>}
                                    </td>

                                    <td className="text-center">
                                      <a href={`${data.download_complete == 1 ? `https://admin.socialwalls.com/wallimages/archive/${data.foldername}.zip?v=${Math.floor(Math.random() * 100000)}` : "javascript:void(0)"}`}
                                        className={`tooltips ${data.download_complete == 1 ? 'readyDwnld' : null} `} data-original-title="Download">
                                         <FontAwesomeIcon type={'solid'} icon={'download'} iconClass=""/>
                                      </a>
                                    </td>
                                  </tr>)
                                 })}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    :
                    <form onSubmit={handleSubmit(onCustomPostSubmit)} className="maintainPopUp noLoader" method="post" accept-charset="utf-8">
                      <div className="downloadImgColm p-4">
                        <div className="customPostSec postcWrapC">
                          <div className="wallcreateshow">
                            <div className="portlet-body">
                                {downloadRequest ?
                                <div className="text-end">
                                  <Button variant='primary' onClick={(e) => setdownloadImage(0)} title="create" data-theme="dark" data-bs-toggle="tooltip" className="popUp maintainPopUp creatNewPostBtn tooltips" data-popup-width="data-width='750px'"><FontAwesomeIcon type={'regular'} icon={'chevron-left'} iconClass="text-white fs-6 me-1"/> Back</Button>
                                </div> : null}

                                <div className="downldSlctWalBlock downloadImages_wrap">
                                    <div className="form-group">
                                      <label htmlFor="" className="columnTitle">
                                        Select Wall
                                      </label>
                                      <div className="input-group flex-nowrap">
                                        <span className="input-group-text">
                                          <FontAwesomeIcon type={'solid'} icon={'grid-2'} iconClass="fa-duotone"/>
                                        </span>
                                        <Select className="w-100" onChange={(e) => setdownloadwallId(e.value)} styles={{ width: '100%' }} options={downloadWall} defaultValue={downloadWall[0]} />
                                      </div>

                                      {!downloadwallId ? <div>
                                        <input  {...register("wall", { required: true, required: 'This field is required.' })} type="hidden" defaultValue={''} />
                                        {errors.wall && <span className="text-error">{errors.wall.message}</span>} </div>
                                        : null}
                                    </div>
                                </div>
                            </div>
                            <div className="text-center formFtr">
                              <span className="errorMessage"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <div className="d-flex align-items-center justify-content-end w-100">
                          <div className="card-toolbar">
                            <button onClick={(e) => closedwonloadImage()} type="button" className="btn btn-secondary me-4" data-bs-dismiss="modal">Cancel</button>
                            <button type="submit" className={`btn btn-primary ${spinner ? `spinner spinner-white spinner-right disabled` : null}`}>Download Images</button>
                          </div>
                        </div>
                      </div>
                    </form>
                    : null }

            </Modal.Body>
          </Modal>

          : null

        :

        <Modal size="lg" dialogClassName="modal-dialog-centered modal-overflow personalizePopupModal dynamic-popup" className='dynamic-popup' show={showdwonloadImage} onHide={closedwonloadImage}>

          <Modal.Body>
          <Modal.Header className='p-0 border-0' closeButton>
          </Modal.Header>

            <div className="row customPostSec postcWrapC">
              <div className="col-md-12 wallcreateshow">
                <div className="portlet-body">
                  <div className="modal-body">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="upgredeMain text-center">
                          <div className="Errorimage pb-3">
                            <img src={baseUrl(`error/download-images-error.png`)}  className="img-fluid" width={500} height={300} />
                          </div>

                          <div className="permissionMsg mt-4 px-4">
                            <h4 className="ErrorMsg">Download Images</h4>
                            <p className="msgSec">Download images from your feed and repurpose it on other marketing touchpoints.</p>

                            <div className="buttonUpgred mb-sm-5 mb-3">
                              <a href="javascript:;" id="addonFeaturesScroll" onClick={(e) => dispatch(togglePlanSection_D(true))} className="commanBtn btn btn-primary px-5 d-inline-block"> Upgrade Now </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

      }

    </>
  );
};

export default DownloadImage;
